.bm{flex-shrink:0;}